import { createSection } from '@formkit/inputs'

/**
 * Contains the action buttons for a multi-step step.
 *
 * @public
 */
export const stepActions = createSection('stepActions', () => ({
  $el: 'div',
}))
